import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import SelectionOrderProvider from '../../context/SelectionOrderContext';
import SelectionOrder from '../../components/Orders/SelectionOrder/SelectionOrder';

const SelectionOrderPage = () => {
  const location = useLocation();
  const { selectionId } = useParams();
  
  // Utiliser l'ID depuis les paramètres d'URL ou les mélanges depuis l'état de navigation
  const id = selectionId;
  const selectedMixtures = location.state?.selectedMixtures || [];
  
  return (
    <SelectionOrderProvider selectionId={id} selectedMixtures={selectedMixtures}>
      <SelectionOrder />
    </SelectionOrderProvider>
  );
};

export default SelectionOrderPage; 